import api from '../../utils/api'
import apiSubmissionError from '../../utils/apiSubmissionError'

export const getCustomersApi = (params) =>
  api.get('/managers/customers', { params })
export const getCustomerByIdApi = (id) => api.get(`/managers/customers/${id}`)
export const deleteCustomerByIdApi = (id) => api.delete(`/managers/customers/${id}`)
export const createCustomerApi = (data) => api.post(`/managers/customers`, data).catch(apiSubmissionError)
export const updateCustomerApi = (id, data) => api.put(`/managers/customers/${id}`, data).catch(apiSubmissionError)
